export enum PdfOrientationType {
  LANDSCAPE = 'landscape',
  PORTRAIT = 'portrait',
}
